<div class="container" [ngClass]="{'none': totalN === 0}">
    <div class="row w-padding rounded-xl bg-white shadow-card">
        <div class="tables offers-container my-offer">
            <div class="offers-header" *ngIf="!isEmpty">
                <!---->
                <div class="seller content_h">
                    <h2 [ngClass]="{'down': !projectListOpen, 'up': projectListOpen}" (click)="toggleSelectProject()">{{ 'bid.project' | translate }}</h2>
                    <div *ngIf="projectListOpen" class="abs-container">
                        <div class="selector-container">
                            <p class="title">{{ 'movements.filter_by' | translate }} <span *ngIf="filterByP !== ''" (click)="reset()">{{ 'movements.delete' | translate }}</span></p>
                            <p class="selector" *ngFor="let item of projectList" [ngClass]="{'checked': item === filterByP }" (click)="filterByProjects(item)">{{ item }}</p>
                        </div>
                    </div>
                </div>
                <h2 class="hidden-lg"></h2>
                <h2 class="share" (click)="orderByShare()" [ngClass]="{'down': !orderBestShare, 'up': orderBestShare}">{{ 'offer.shares' | translate }}</h2>
                <h2 class="em-value" (click)="orderByPrice()" [ngClass]="{'down': !orderBestPrice, 'up': orderBestPrice}">{{ 'offer.best-bid' | translate }}</h2>
                <h2 class="bid">{{ 'offer.ends' | translate }}</h2>
                <div class="status_content">
                    <h2 class="status" [ngClass]="{'down': !statusOpen, 'up': statusOpen}" (click)="toggleStatusProject()">{{ 'movements.status' | translate }}</h2>
                    <div *ngIf="statusOpen" class="relative-container">
                        <div class="selector-container">
                            <p class="title">{{ 'movements.filter_by' | translate }} <span *ngIf="filterByS !== ''" (click)="reset()">{{ 'movements.delete' | translate }}</span></p>
                            <p class="selector" *ngFor="let item of statusList" [ngClass]="{'checked': item.id === filterByS }" (click)="filterList(item.id)">{{ item.name }}</p>
                        </div>
                    </div>
                </div>
                <!---->
            </div>

            <ng-container *ngFor="let dataItem of dataListFiltered">

                <div [ngClass]="isShow && idSelected == dataItem.id ? 'open' : ''" class="offers-content">
                    <p class="project" (click)="viewOfferDetails(dataItem)">
                        <span class="mark"
                        [ngClass]="{'mark-orange': dataItem.project_technology == 1, 'mark-blue': dataItem.project_technology == 2}"></span>
                        {{ dataItem.project_name }}
                    </p>
                    <p class="hidden-lg">
                        <i *ngIf="dataItem.sold_status !== 'ok' && dataItem.sold_status !== 'ko'" class="ico"
                        [ngClass]="{'ico-info-orange': dataItem.status == 'pending_acceptation' || (dataItem.status === 'active' && dataItem.best_bid > 0),
                        'ico-info-green': dataItem.notification }"></i>
                        <label class="label-tag"
                            [ngClass]="{'label-tag-orange': dataItem.status == 'active' || dataItem.status == 'pending_acceptation', 'label-tag-green': dataItem.status == 'sold', 'label-tag-red': dataItem.status == 'not_sold'}">
                            <span *ngIf="dataItem.status == 'active' || dataItem.status == 'pending_acceptation'">{{ 'offer.active-status' | translate }}</span>
                            <span *ngIf="dataItem.status == 'sold'">{{ 'offer.sold-status' | translate }}</span>
                            <span *ngIf="dataItem.status == 'not_sold'">{{ dataItem.tagName }}</span>
                        </label>
                    </p>
                    <p class="share" (click)="viewOfferDetails(dataItem)"><span class="hidden-lg">{{ 'offer.shares' | translate }}</span> {{ dataItem.amount }}</p>
                    <p class="em-value" (click)="viewOfferDetails(dataItem)"
                    [ngClass]="{ 'text-green': dataItem.status == 'sold'}">
                    <span class="hidden-lg">{{ 'offer.best-bid' | translate }}</span> {{ dataItem.best_bid | localeNumber }} €</p>
                    <p class="bid" (click)="viewOfferDetails(dataItem)"><span class="hidden-lg">
                        {{ 'offer.ends' | translate }}</span>
                        <ng-container *ngIf="dataItem.status == 'active' || dataItem.status == 'pending_acceptation'">
                            {{ dataItem.decision_due_date | timeLeft }}
                        </ng-container>
                        <ng-container *ngIf="dataItem.status != 'active' && dataItem.status != 'pending_acceptation'">
                            -
                        </ng-container>
                    </p>

                    <p class="action" (click)="viewOfferDetails(dataItem)">
                        <i class="ico" *ngIf="dataItem.sold_status !== 'ok' && dataItem.sold_status !== 'ko'"
                        [ngClass]="{'ico-info-orange': dataItem.status == 'pending_acceptation' || (dataItem.status === 'active' && dataItem.best_bid > 0),
                        'ico-info-green': dataItem.notification }"></i>
                        <label class="label-tag"
                            [ngClass]="{'label-tag-orange': dataItem.status == 'active' || dataItem.status == 'pending_acceptation', 'label-tag-green': dataItem.status == 'sold', 'label-tag-red': dataItem.status == 'not_sold'}">
                            <span *ngIf="dataItem.status == 'active' || dataItem.status == 'pending_acceptation'">{{ 'offer.active-status' | translate }}</span>
                            <span *ngIf="dataItem.status == 'sold'">{{ 'offer.sold-status' | translate }}</span>
                            <span *ngIf="dataItem.status == 'not_sold'">{{ dataItem.tagName }}</span>
                        </label>
                        <a class="ico ico-edit"></a>
                        <a class="a-link hidden-lg">{{ 'offer.view-details' | translate }}</a>
                        <i class="ico ico-arrow-right-green hidden-sm"></i>
                    </p>

                    <p (click)="toggleDisplay(dataItem.id)" class="show-more hidden-lg"> <i class="ico ico-arrow"></i>
                    </p>
                </div>

            </ng-container>
        </div>

        <fun-new-button *ngIf="totalN > 0" [buttonType]="btnType" title="{{ 'offer.create-offer-button' | translate }}"
            (eventClick)="onEventClickCreateOffer()"></fun-new-button>
    </div>
</div>
<fun-skeleton-list *ngIf="!loaded"></fun-skeleton-list>
<div class="container" *ngIf="totalN === 0">
    <div class="row w-padding final-step offer">
        <div class="col-12">
            <h3></h3>
            <p class="font-sans text-l text-eggplant-100">{{ 'offer.create-offer-text' | translate }}</p>
            <div class="container">
                <fun-new-button [buttonType]="btnType" title="{{ 'offer.create-offer-button' | translate }}" class="button" (eventClick)="onEventClickCreateOffer()">
                </fun-new-button>
            </div>
        </div>
    </div>
</div>